/*Definição de valores para elementos do style components para padronização do app */

import { css } from 'styled-components'

/* Breakpoints — corte de mobile mais alto que o clássico 480px porque vários
   painéis do app (Sidebar 240-320px, CorrelationDrawer 440px, ModalOptions 500px)
   já são mais largos que isso; o critério é "deve virar empilhado/overlay". */
export const BreakpointMobile = 600
export const BreakpointTablet = 1024

export const media = {
    mobile: (...args: Parameters<typeof css>) => css`
        @media (max-width: ${BreakpointMobile}px) { ${css(...args)} }
    `,
    tabletDown: (...args: Parameters<typeof css>) => css`
        @media (max-width: ${BreakpointTablet}px) { ${css(...args)} }
    `,
}

export const BackgroundContainer = 'linear-gradient(150deg, #1c2530, #101720)'

export const ModalBackground = 'rgba(20, 26, 33, 0.98)'

export const TitleColor = "#FFF"

export const tecdinBlue = "rgba(82, 146, 209, 1)"

export const tecdinGreen = "rgba(197, 235, 127, 1)"

/* Tokens "Glass Elevated" — cards translúcidos com blur e brilho interno sutil */
export const GlassCardBg = "rgba(255,255,255,0.045)"
export const GlassCardBorder = "1px solid rgba(255,255,255,0.09)"
export const GlassCardShadow = "0 8px 28px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.06)"
export const GlassCardBlur = "blur(14px)"

/* Cores de severidade */
export const SeverityRed = "#F03F3F"
export const SeverityYellow = "#E5D34A"
export const SeverityOrange = "#E8A84C"
export const SeverityGreen = "#92B258"
export const SeverityBlue = "#5292D1"

/* Gradiente horizontal no fundo do card, indicando severidade (substitui faixa lateral) */
export const StatusWashCritico = "linear-gradient(90deg, rgba(240,63,63,0.22), rgba(255,255,255,0.045) 68%)"
export const StatusWashAtencao = "linear-gradient(90deg, rgba(229,211,74,0.22), rgba(255,255,255,0.045) 68%)"
export const StatusWashOk = "linear-gradient(90deg, rgba(146,178,88,0.18), rgba(255,255,255,0.045) 68%)"
export const StatusWashInativa = "linear-gradient(90deg, rgba(255,255,255,0.1), rgba(255,255,255,0.045) 68%)"